const MATERIALS = ['msand', 'csand', 'rsand', '12mm', '20mm'];

export function correctionFactor(absorption, moisture) {
  return Number((parseFloat(absorption) || 0) - (parseFloat(moisture) || 0)).toFixed(2);
}

export function applyCorrectionFactors(fields) {
  const next = { ...fields };
  MATERIALS.forEach((material) => {
    next[`correction_factor_${material}`] = correctionFactor(
      next[`absorption_${material}`],
      next[`moisture_${material}`],
    );
  });
  return next;
}

export function mapMoistureApiToInputs(response) {
  const prefix = response.prefix || '';
  const slNo = response.sl_no || '';
  const fields = {
    id: response.id,
    plant_id: response.plant_id,
    plant_name: response.plant_name || response.plant_alias || '',
    prefix,
    sl_no: slNo,
    mc_no: response.mc_no || (prefix && slNo ? `${prefix}${slNo}` : slNo || ''),
    sl_dt: response.sl_dt || '',
    sl_time: response.sl_time || '',
    moisture_msand: response.moisture?.msand ?? 0,
    moisture_csand: response.moisture?.csand ?? 0,
    moisture_rsand: response.moisture?.rsand ?? 0,
    moisture_12mm: response.moisture?.['12mm'] ?? 0,
    moisture_20mm: response.moisture?.['20mm'] ?? 0,
    absorption_msand: response.absorption?.msand ?? 0,
    absorption_csand: response.absorption?.csand ?? 0,
    absorption_rsand: response.absorption?.rsand ?? 0,
    absorption_12mm: response.absorption?.['12mm'] ?? 0,
    absorption_20mm: response.absorption?.['20mm'] ?? 0,
  };
  return applyCorrectionFactors(fields);
}
